import React from 'react';

/** Organization sidebar icon for the Activation Templates tab: a simple document with lines. */
const ActivationTemplatesTabIcon = (props: any) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M5 3.5C5 2.94772 5.44772 2.5 6 2.5H12L15.5 6V16.5C15.5 17.0523 15.0523 17.5 14.5 17.5H6C5.44772 17.5 5 17.0523 5 16.5V3.5Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M12 2.5V6H15.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M7.5 10H12.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    <path d="M7.5 13H12.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
  </svg>
);

export default ActivationTemplatesTabIcon;
